import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { PropsWithClassName } from '@/types/common';
import * as styles from './AnimatedSlides.module.scss';

type Props = PropsWithClassName<{
  slides: ReactNode[];
  activeIndex: number;
}>;

const AnimatedSlides: FC<Props> = ({ slides, activeIndex, className }) => (
  <TransitionGroup>
    {activeIndex >= 0 && activeIndex < slides.length ? (
      <CSSTransition
        timeout={1500}
        classNames={{
          enter: styles.groupEnter,
          enterActive: styles.groupEnterActive,
          exit: styles.groupExit,
          exitActive: styles.groupExitActive,
        }}
      >
        <div className={cx(styles.main, className)}>
          <TransitionGroup>
            {slides.map((slide, index) =>
              index === activeIndex ? (
                <CSSTransition
                  key={index}
                  timeout={1500}
                  classNames={{
                    enter: styles.itemEnter,
                    enterActive: styles.itemEnterActive,
                    exit: styles.itemExit,
                    exitActive: styles.itemExitActive,
                  }}
                >
                  {slide}
                </CSSTransition>
              ) : null
            )}
          </TransitionGroup>
        </div>
      </CSSTransition>
    ) : null}
  </TransitionGroup>
);

export default AnimatedSlides;
